import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { ModulePageHeader } from '~/components/ModulePageHeader/ModulePageHeader';

export type CountryReportDetailHeaderProps = {
  name: string;
};

export const CountryReportDetailHeader = ({ name }: CountryReportDetailHeaderProps) => {
  const { t } = useTranslation(I18nNamespace.riskSustainability, { keyPrefix: 'CountryReportDetailHeader' });

  return <ModulePageHeader title={t('title', { name })} />;
};
